export const slides = [
  "/maria/banner/MP1.png",
  "/maria/banner/MP2.png",
  "/maria/banner/MP3.png",
  "/maria/banner/MP4.png",
  "/maria/banner/MP5.png",
  "/maria/banner/MP6.png",
  "/maria/banner/MP7.png",
];
